module.exports = __webpack_public_path__ + "img/action-like-hover.2094fc47.svg";